export default "<ion-app>\n  \n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n";